export const PERMISSION = {
    ADMIN: "Admin",
    LOAN_OFFICER: "LoanOfficer"
};
